/**
 * Haalt de event-code uit een gescande of gedeeplinkte waarde.
 */
export function extractEventCode(raw: string | null | undefined): string | null {
	if (!raw) return null;
	const value = raw.trim();
	if (!value) return null;

	const match = value.match(/\/event\/([^/?#]+)/i);
	if (match?.[1]) {
		const code = decodeURIComponent(match[1]).trim();
		return code.length > 0 ? code : null;
	}

	// No deeplink path: a bare token (not a URL) is treated as a raw code.
	if (!value.includes('://') && !value.includes('/')) {
		return value;
	}

	return null;
}
